import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWheelchairRamp = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 24,
	viewBox: "0 0 25 24",
	width: 25,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m9.27145 6.47082c-.04915-.4924-.48816-.85172-.98056-.80258-.4924.04915-.85173.48816-.80258.98056l.89157-.08899zm-.35762 5.43838-.89157.089.08899.8916.89157-.089zm7.35547-.7341.7576-.4784-.2956-.4682-.551.055zm3.2086 5.0824-.7576.4783.4148.6571.7092-.3177zm2.3057-.0512.8177-.3664-.7328-1.6353-.8176.3663.3663.8177zm-13.40372-9.64649-.89157.08899.53395 5.3494.89157-.089.89157-.089-.53395-5.34938zm.53395 5.34939.08899.8916 7.35548-.7342-.089-.8915-.089-.8916-7.35546.7342zm7.35547-.7341-.7577.4783 3.2087 5.0824.7576-.4783.7577-.4783-3.2087-5.0825zm3.2086 5.0824.3664.8177 1.9393-.8689-.3664-.8177-.3663-.8177-1.9393.8689z",
			fill: "#000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m8.37988 6.55964c1.1079-.11058 1.91642-1.09836 1.80582-2.20626s-1.09838-1.91639-2.20628-1.80581c-1.1079.11059-1.91639 1.09836-1.8058 2.20626.11058 1.10791 1.09836 1.91639 2.20626 1.80581z",
			stroke: "#000",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeOpacity: .87,
			strokeWidth: 1.792
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#000",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "m14.2861 7.09575c.4924-.04915.8518-.48816.8026-.98056-.0491-.4924-.4881-.85173-.9805-.80258l.089.89157zm-4.76969-.42437-.08899-.89157zm-4.81547 5.88332-.89157.089zm5.88336 4.8155.089.8916zm5.8346-4.4101.1359-.8856-1.7712-.2719-.136.8857.8857.1359zm-2.2217-6.75592-.089-.89157-4.68078.4672.08899.89157.08899.89157 4.6807-.4672zm-4.68079.4672-.08899-.89157c-1.65521.16521-3.177.98119-4.23059 2.26842l.69336.56751.69336.56751c.75256-.91945 1.83956-1.50229 3.02185-1.6203zm-3.62622 1.94436-.69336-.56751c-1.05359 1.28724-1.55268 2.94027-1.38746 4.59547l.89157-.089.89157-.0889c-.11801-1.1823.23848-2.3631.99104-3.28255zm-1.18925 3.93896-.89157.089c.16521 1.6552.98118 3.177 2.26842 4.2306l.56751-.6933.56751-.6934c-.91946-.7526-1.5023-1.8396-1.6203-3.0218zm1.94436 3.6263-.56751.6933c1.28723 1.0536 2.94028 1.5527 4.59551 1.3875l-.089-.8916-.089-.8916c-1.18229.1181-2.36304-.2384-3.28249-.991zm3.939 1.1892.089.8916c2.876-.2871 5.3169-2.5086 5.7456-5.3017l-.8856-.1359-.8857-.1359c-.2976 1.9393-2.0433 3.5798-4.1523 3.7903z",
				fillOpacity: .87
			}), /* @__PURE__ */ _jsx("path", {
				d: "m2 19.9922h20.1001v1.79h-20.1001z",
				transform: "matrix(.99505557 -.09931975 .09931975 .99505557 -1.975731 .29749)"
			})]
		})
	]
});
export default SvgWheelchairRamp;
